import { render } from "./ParserResult.vue?vue&type=template&id=b4b485cc&scoped=true"
import script from "./ParserResult.vue?vue&type=script&lang=js"
export * from "./ParserResult.vue?vue&type=script&lang=js"

import "./ParserResult.vue?vue&type=style&index=0&id=b4b485cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b485cc"]])

export default __exports__